var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCampus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 3.75C3 3.33579 3.33579 3 3.75 3H5.25C5.66421 3 6 3.33579 6 3.75V5.25C6 5.66421 5.66421 6 5.25 6H3.75C3.33579 6 3 5.66421 3 5.25V3.75Z",
    fill: "#E1CE00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 3.75C7.5 3.33579 7.83579 3 8.25 3H9.75C10.1642 3 10.5 3.33579 10.5 3.75V5.25C10.5 5.66421 10.1642 6 9.75 6H8.25C7.83579 6 7.5 5.66421 7.5 5.25V3.75Z",
    fill: "#E1CE00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 3C12.3358 3 12 3.33579 12 3.75V5.25C12 5.66421 12.3358 6 12.75 6H14.25C14.6642 6 15 5.66421 15 5.25V3.75C15 3.33579 14.6642 3 14.25 3H12.75Z",
    fill: "#E1CE00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 8.25C3 7.83579 3.33579 7.5 3.75 7.5H5.25C5.66421 7.5 6 7.83579 6 8.25V9.75C6 10.1642 5.66421 10.5 5.25 10.5H3.75C3.33579 10.5 3 10.1642 3 9.75V8.25Z",
    fill: "#E1CE00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 7.5C7.83579 7.5 7.5 7.83579 7.5 8.25V9.75C7.5 10.1642 7.83579 10.5 8.25 10.5H9.75C10.1642 10.5 10.5 10.1642 10.5 9.75V8.25C10.5 7.83579 10.1642 7.5 9.75 7.5H8.25Z",
    fill: "#E1CE00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.25C12 7.83579 12.3358 7.5 12.75 7.5H14.25C14.6642 7.5 15 7.83579 15 8.25V9.75C15 10.1642 14.6642 10.5 14.25 10.5H12.75C12.3358 10.5 12 10.1642 12 9.75V8.25Z",
    fill: "#E1CE00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 12C3.33579 12 3 12.3358 3 12.75V14.25C3 14.6642 3.33579 15 3.75 15H5.25C5.66421 15 6 14.6642 6 14.25V12.75C6 12.3358 5.66421 12 5.25 12H3.75Z",
    fill: "#E1CE00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12.75C7.5 12.3358 7.83579 12 8.25 12H9.75C10.1642 12 10.5 12.3358 10.5 12.75V14.25C10.5 14.6642 10.1642 15 9.75 15H8.25C7.83579 15 7.5 14.6642 7.5 14.25V12.75Z",
    fill: "#E1CE00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 12C12.3358 12 12 12.3358 12 12.75V14.25C12 14.6642 12.3358 15 12.75 15H14.25C14.6642 15 15 14.6642 15 14.25V12.75C15 12.3358 14.6642 12 14.25 12H12.75Z",
    fill: "#E1CE00"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.5C0 0.671574 0.671572 0 1.5 0H16.5C17.3284 0 18 0.671573 18 1.5V22.5C18 23.3284 17.3284 24 16.5 24H1.5C0.671573 24 0 23.3284 0 22.5V1.5ZM16.5 1.5L1.5 1.5V22.5H6V18.75C6 18.3358 6.33579 18 6.75 18H11.25C11.6642 18 12 18.3358 12 18.75V22.5H16.5V1.5Z",
    fill: "#E1CE00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampus);
export default __webpack_public_path__ + "static/media/campus.dce31f28c2f32dfc940531153f409d81.svg";
export { ForwardRef as ReactComponent };